/**
 * Create an array of numbers from 0
 * @param end Non-inclusive end of range
 */
export const range = (end: number): Array<number> => {
  if (!isInteger(end)) {
    throw new Error(`Cannot get a range for non-integer ${end}`);
  }

  return [...Array(end).keys()];
};

const isInteger = (num: number) => num === Math.floor(Math.abs(num));
